import { KeyInfoTextField } from '@dap/sanity/types';
import { Stack, Typography } from '@mui/material';

interface Props {
  value: Omit<KeyInfoTextField, '_type'>;
}

export default function KeyInfoEmail(props: Props) {
  const { value, title } = props.value;

  return (
    <Stack>
      <Typography variant="h6" component="h3">
        {title}
      </Typography>
      <Typography key={value} variant="body2">
        {value}
      </Typography>
    </Stack>
  );
}
